import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"

export default ({ data }) => (
  <Layout>
    <h1>About {data.site.siteMetadata.title}</h1>
    <p>
      This site was inspired by <a href="https://hermy0211.github.io/framer30/" target="_blank">30 Days of Framer X</a>. As a self-taught designer I sometimes find it hard to pick what to learn next, how to best use the time I allocate to keeping my skills up to date. When I found out about 30 Days of Framer X I was inspired by it. I'd been meaning to learn Framer X for a while and thought this was a smart way to do that. To do this project I looked at tutorials and Framer X documentation. To build this site I learned about <a href="https://www.gatsbyjs.org/" target="_blank">Gatsby</a>.

      You can find more about me and my work <a href="http://andreadelrio.me" target="_blank">here</a>.
    </p>
  </Layout>
)

export const query = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
  }
`
